const teal = "#007096";
const gold = "#FFCC00";
const aubergine = "#87027B";
const sage = "#007A33";
const blueberry = "#004C97";
const orange = "#E5721D";
const raspberry = "#D50032";
const lime = "#ADCB00";
const almond = "#914d17";
const grey = "#53565A";
const dark = "#000000";

const white = "#FFFFFF";
const black = "#000000";

const gray100 = "#f8f9fa";
const gray200 = "#e9ecef";
const gray300 = "#dee2e6";
const gray400 = "#ced4da";
const gray500 = "#adb5bd";
const gray600 = "#6c757d";
const gray700 = "#495057";
const gray800 = "#343a40";
const gray900 = "#212529";

export const theme = {
  primary: teal,
  secondary: gold,
  success: sage,
  info: blueberry,
  warning: orange,
  danger: raspberry,
  light: gray100,

  gray100,
  gray200,
  gray300,
  gray400,
  gray500,
  gray600,
  gray700,
  gray800,
  gray900,

  teal,
  gold,
  aubergine,
  sage,
  blueberry,
  orange,
  raspberry,
  lime,
  almond,
  grey,
  dark,
  white,
  black
};
